module.exports = __webpack_public_path__ + "static/pomodoro-97115ac3c95e34f0844c26e7e48625e6.png";